import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Root element not found");
}

rootEl.innerHTML = "";
createRoot(rootEl).render(<App />);

if (typeof window !== "undefined") {
  const loadFonts = () => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700&family=Noto+Sans+Bengali:wght@400;700&display=optional";
    link.media = "print";
    link.onload = () => {
      link.media = "all";
    };
    document.head.appendChild(link);
    import("./lib/performance").then((module) => module.loadDeferredFonts()).catch(() => {});
  };

  window.addEventListener(
    "load",
    () => {
      if ("requestIdleCallback" in window) {
        (window as Window & { requestIdleCallback: (callback: IdleRequestCallback, options?: IdleRequestOptions) => number }).requestIdleCallback(loadFonts, { timeout: 3000 });
        return;
      }
      globalThis.setTimeout(loadFonts, 2500);
    },
    { once: true },
  );
}
